import $ from 'jquery';

if (window.feeCalculator !== undefined && window.feeCalculator.fees !== undefined && window.feeCalculator.incomeClass !== undefined) {
    let incomeClass = window.feeCalculator.incomeClass;
    let fees = window.feeCalculator.fees;
    let maxIncomeClass = incomeClass.length - 1;
    let $feeCalculator = $('.fee-calculator');

    $feeCalculator.on('submit', function (e) {
        e.preventDefault();
        let parents = $feeCalculator.find('#fee-calculator-parents').val();
        let children = $feeCalculator.find('#fee-calculator-children').val();
        let childrenSchool = $feeCalculator.find('#fee-calculator-school-children').val();

        if (childrenSchool > children) {
            $feeCalculator.find('#fee-calculator-school-children').val(children);
        }

        let income = parseInt($feeCalculator.find("#fee-calculator-kindergarten-income").val());

        // Force parseInt value into input field
        $feeCalculator.find("#fee-calculator-kindergarten-income").val(income)

        var schoolFee = 0;


        var currFee = fees[parents][children][childrenSchool];

        if (income <= incomeClass[0]) {
            schoolFee = currFee[0];
        } else if (income >= incomeClass[maxIncomeClass]) {
            schoolFee = currFee[maxIncomeClass];
        } else {
            let k = 0;
            while (income >= incomeClass[k]) {
                k++;
            }
            k = k - 1;
            schoolFee = Math.round((income - incomeClass[k]) / (incomeClass[k + 1] - incomeClass[k]) * (currFee[k + 1] - currFee[k]) + currFee[k]);
        }

        if (isNaN(schoolFee)) {
            schoolFee = 0;
            $feeCalculator.find('.fee-calculator__result-wrap').addClass('fee-calculator__result-wrap--hidden');
        } else {
            $feeCalculator.find('.fee-calculator__result-wrap').removeClass('fee-calculator__result-wrap--hidden');
        }

        $feeCalculator.find('.fee-calculator__result').text(schoolFee);
    });
}
